import { z } from 'zod';

/**
 * Wire do `GET /flight/searches/recent` (#2362): o BFF valida a
 * resposta com este schema antes do `res.json`, e o web-chat a lê com ele na
 * borda. Uma busca recente é exatamente o critério que `POST /flight/search`
 * recebeu (IATA, datas `YYYY-MM-DD`, cabine), pronto para ser reenviado:
 * `returnDate` ausente ⇔ somente ida. Só ida-e-volta e somente-ida entram
 * (decisão 2026-09-10); o nome das cidades é do leitor, que já tem a busca de
 * aeroportos por código.
 *
 * Mais recente primeiro, na ordem em que o back-end devolve. Pode vir vazio —
 * recente é conveniência, e o BFF degrada para `[]` em qualquer falha.
 */
export const FlightRecentSearchSchema = z.object({
  origin: z.string().regex(/^[A-Z]{3}$/),
  destination: z.string().regex(/^[A-Z]{3}$/),
  departureDate: z.iso.date(),
  returnDate: z.iso.date().optional(),
  cabin: z.enum(['economy', 'premium', 'business', 'first']).optional(),
});

export const FlightRecentSearchesResponseSchema = z.object({
  searches: z.array(FlightRecentSearchSchema),
});
